import { type RouteRecordRaw } from "vue-router";

import { APP_SETTINGS_SUBSCRIPTIONS_ROUTES as SUBS } from "@/Generated/Routes/paths";
import { buildBeforeEnterChain, isPatientGuard } from "@/Router/guards";

export default [
  {
    path: SUBS.root.path,
    components: {
      main: () => import("@/Views/settings/Subscription/Layout.vue"),
    },
    meta: { sidebar: false, drawer: false, noHeader: true },
    beforeEnter: buildBeforeEnterChain(isPatientGuard),
    children: [
      {
        ...SUBS.root,
        component: () => import("@/Views/MainLanding.vue"),
        meta: {
          i18nTitle: "settings.subscriptions-title",
        },
      },
      {
        ...SUBS.payment.root,
        meta: {
          i18nTitle: "user.settings.subscription.payment.payment-title",
        },
        component: () => import("@/Views/settings/Subscription/Views/Payment/index.vue"),
      },
      {
        ...SUBS.payment.add.root,
        meta: {
          i18nTitle: "user.settings.subscription.payment.add_payment_method",
        },
        component: () => import("@/Views/settings/Subscription/Views/Payment/Add/index.vue"),
      },
      {
        ...SUBS.plan.root,
        meta: {
          i18nTitle: "user.settings.subscription.plan.plan-title",
        },
        component: () => import("@/Views/settings/Subscription/Views/Plan/index.vue"),
      },
      {
        ...SUBS.privatePlan.root,
        meta: {
          i18nTitle: "user.settings.subscription.plan.plan-title",
        },
        component: () => import("@/Views/settings/Subscription/Views/Plan/index.vue"),
      },
      {
        ...SUBS.promoCode.root,
        meta: {
          i18nTitle: "settings.subscription.patient.promo_code.insert_promotional_code",
        },
        component: () => import("@/Views/settings/Subscription/Views/PromoCode.vue"),
      },
      {
        ...SUBS.cancel.root,
        meta: {
          i18nTitle: "settings.subscription.patient.cancel",
        },
        component: () => import("@/Views/settings/Subscription/Views/Cancel.vue"),
      },
      {
        ...SUBS.cancel.reason.root,
        meta: {
          i18nTitle: "settings.subscription.patient.cancel",
        },
        component: () => import("@/Views/settings/Subscription/Views/CancelReason.vue"),
      },
      {
        ...SUBS.sessions.root,
        meta: {
          i18nTitle: "settings.subscription.sessions_payments_records",
        },
        component: () => import("@/Views/settings/Subscription/Views/Sessions/index.vue"),
      },
      {
        ...SUBS.extra_sessions.root,
        component: () => import("@/Views/settings/Subscription/Views/ExtraSessions/index.vue"),
        meta: {
          i18nTitle: "user.settings.subscription.sessions_extra",
        },
        beforeEnter: buildBeforeEnterChain(isPatientGuard),
      },
    ],
  },
] as RouteRecordRaw[];
